// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-page-container {
  flex: 1 1;
  font-family: Arial, sans-serif;
  padding: 10px;
  height: 100%;
  overflow-y: auto;
}

.PhotoContainer {
  flex: 1 1;
  font-family: Arial, sans-serif;
  padding: 10px;
  height: 100%;
  overflow: scroll;

}

.PhotoTitle {
  font-size: 18px;
  margin-bottom: 16px;
}

.PhotoForm {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
}

.PhotoForm input {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
}

.PhotoForm button {
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

.PhotoError {
  color: red;
  font-size: 13px;
  margin-top: 10px;
}

.PhotoCardContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 10px;
}

.PhotoCard {
  background: white;
  border: 1px solid #ddd;
  padding: 10px 15px;
  width: 350px;
  font-size: 14px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 220px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.PhotoCard h2 {
  font-size: 16px;
  margin: 0 0 4px 0;
}

.PhotoCard ul {
  padding-left: 16px;
  margin: 0;
}

.PhotoCard p,
.PhotoCard li {
  margin: 2px 0;           /* вместо стандартных 8–16px */
  line-height: 1.3;        /* уменьшить межстрочный интервал */
  font-size: 13px;         /* можно чуть уменьшить шрифт */
}

.PhotoGallery {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  overflow-y: hidden;
  max-height: 200px;
  padding-bottom: 6px;
  margin-top: 8px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.PhotoGallery::-webkit-scrollbar {
  height: 6px;
}

.PhotoGallery::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}

.PhotoGallery img {
  flex-shrink: 0;
  max-height: 180px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

/* Маркировки */
.PhotoMarks {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 120px;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.PhotoMarks::-webkit-scrollbar {
  width: 6px;
}

.PhotoMarks::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}

.PhotoMarkItem {
  display: flex;
  align-items: center;
  font-size: 13px;
  gap: 6px;
}

/* Кнопка удаления слева */
.PhotoMarkItem button {
  background: #e57373;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 12px;
  cursor: pointer;
}

/* Текст марки с троеточием и полным отображением при наведении */
.PhotoMarkItem span {
  display: inline-block;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease-in-out;
}

.PhotoMarkItem span:hover {
  white-space: normal;
  overflow: visible;
  background: #f9f9f9;
  position: relative;
  z-index: 1;
  padding: 2px;
  box-shadow: 0 0 2px rgba(0,0,0,0.1);
}

/* Добавление марки */
.PhotoAddMark {
  display: flex;
  align-items: center;
  gap: 6px;
}

.PhotoAddMark input {
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 6px;
  flex: 1 1;
}

.PhotoAddMark button {
  padding: 4px 8px;
  background: #28a745;
  color: white;
  border: none;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
}

.PhotoMarkStatus {
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Developer/TestPages/CheckPhoto/PhotoGalleryByDate.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,aAAa,YAAY,8BAA8B;EACvD,gBAAgB,SAAS,mCAAmC;EAC5D,eAAe,UAAU,+BAA+B;AAC1D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".photo-page-container {\r\n  flex: 1;\r\n  font-family: Arial, sans-serif;\r\n  padding: 10px;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.PhotoContainer {\r\n  flex: 1;\r\n  font-family: Arial, sans-serif;\r\n  padding: 10px;\r\n  height: 100%;\r\n  overflow: scroll;\r\n\r\n}\r\n\r\n.PhotoTitle {\r\n  font-size: 18px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.PhotoForm {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.PhotoForm input {\r\n  padding: 4px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n}\r\n\r\n.PhotoForm button {\r\n  background-color: #007bff;\r\n  color: white;\r\n  padding: 5px 10px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n}\r\n\r\n.PhotoError {\r\n  color: red;\r\n  font-size: 13px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.PhotoCardContainer {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.PhotoCard {\r\n  background: white;\r\n  border: 1px solid #ddd;\r\n  padding: 10px 15px;\r\n  width: 350px;\r\n  font-size: 14px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  min-height: 220px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.PhotoCard h2 {\r\n  font-size: 16px;\r\n  margin: 0 0 4px 0;\r\n}\r\n\r\n.PhotoCard ul {\r\n  padding-left: 16px;\r\n  margin: 0;\r\n}\r\n\r\n.PhotoCard p,\r\n.PhotoCard li {\r\n  margin: 2px 0;           /* вместо стандартных 8–16px */\r\n  line-height: 1.3;        /* уменьшить межстрочный интервал */\r\n  font-size: 13px;         /* можно чуть уменьшить шрифт */\r\n}\r\n\r\n.PhotoGallery {\r\n  display: flex;\r\n  gap: 6px;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  max-height: 200px;\r\n  padding-bottom: 6px;\r\n  margin-top: 8px;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #ccc transparent;\r\n}\r\n\r\n.PhotoGallery::-webkit-scrollbar {\r\n  height: 6px;\r\n}\r\n\r\n.PhotoGallery::-webkit-scrollbar-thumb {\r\n  background-color: #bbb;\r\n  border-radius: 4px;\r\n}\r\n\r\n.PhotoGallery img {\r\n  flex-shrink: 0;\r\n  max-height: 180px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\r\n}\r\n\r\n/* Маркировки */\r\n.PhotoMarks {\r\n  margin-top: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  max-height: 120px;\r\n  overflow-y: auto;\r\n  padding-right: 4px;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #ccc transparent;\r\n}\r\n\r\n.PhotoMarks::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.PhotoMarks::-webkit-scrollbar-thumb {\r\n  background-color: #bbb;\r\n  border-radius: 4px;\r\n}\r\n\r\n.PhotoMarkItem {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 13px;\r\n  gap: 6px;\r\n}\r\n\r\n/* Кнопка удаления слева */\r\n.PhotoMarkItem button {\r\n  background: #e57373;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 2px 6px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Текст марки с троеточием и полным отображением при наведении */\r\n.PhotoMarkItem span {\r\n  display: inline-block;\r\n  max-width: 160px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.PhotoMarkItem span:hover {\r\n  white-space: normal;\r\n  overflow: visible;\r\n  background: #f9f9f9;\r\n  position: relative;\r\n  z-index: 1;\r\n  padding: 2px;\r\n  box-shadow: 0 0 2px rgba(0,0,0,0.1);\r\n}\r\n\r\n/* Добавление марки */\r\n.PhotoAddMark {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.PhotoAddMark input {\r\n  padding: 4px 6px;\r\n  font-size: 13px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  flex: 1;\r\n}\r\n\r\n.PhotoAddMark button {\r\n  padding: 4px 8px;\r\n  background: #28a745;\r\n  color: white;\r\n  border: none;\r\n  font-size: 13px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.PhotoMarkStatus {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  margin-top: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
